import { call, put, select, takeEvery } from 'redux-saga/effects';
import { sagaApiGenWithPromise } from 'utils/sagaApiGeneratorHelpers';
import * as usersAPI from '../api/audio';
import { audioGetAll, audioGetAllFailed, audioGetAllSucceeded, audioGetPresignedUrl, audioGetPresignedUrlFailed, audioGetPresignedUrlSucceeded, audioUpload, audioUploadFailed, audioUploadSucceeded, } from '../reducers/audio';
// Saga
export const audioSagas = [
    takeEvery(audioGetAll.toString(), sagaApiGenWithPromise(usersAPI.getAudios, audioGetAllSucceeded, audioGetAllFailed)),
    takeEvery(audioGetPresignedUrl.toString(), audioGetPresignedGen),
    takeEvery(audioGetPresignedUrlSucceeded.toString(), audioUploadGen),
];
export function* audioUploadGen(action) {
    try {
        const getProfile = (state) => state.settings.profile.profile;
        const profileState = yield select(getProfile);
        yield put(audioUpload());
        yield call(usersAPI.uploadAudio, action.payload);
        yield put(audioUploadSucceeded({
            url: action.payload.presigned.download_url,
            filename: action.payload.filename,
            created_by: profileState,
        }));
    }
    catch (exception) {
        console.warn(exception);
        yield put(audioUploadFailed({
            error: exception.message,
        }));
    }
}
export function* audioGetPresignedGen(action) {
    try {
        const result = yield call(usersAPI.getPresigned, action.payload);
        yield put(audioGetPresignedUrlSucceeded({
            presigned: result.data,
            files: action.payload.files,
            filename: action.payload.filename,
        }));
    }
    catch (exception) {
        console.warn(exception);
        yield put(audioGetPresignedUrlFailed({
            error: exception.message,
        }));
    }
}
